import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<div class=\"right\" ...attributes>{{yield}}</div>\n")